
const ajaxUrl = {
  addPdnProfileJson: '/lte/ems/subscriber/epcunms/getParamJson',
  modPdnProfileJson: '/lte/ems/subscriber/epcunms/getParamJson',
  addProfileJson: '/lte/ems/subscriber/epcunms/getParamJson',
  modProfileJson: '/lte/ems/subscriber/epcunms/getParamJson',
  addLteUserJson: '/lte/ems/subscriber/epcunms/getParamJson',
  modLteUserJson: '/lte/ems/subscriber/epcunms/getParamJson',
  addBatchUserJson: '/lte/ems/subscriber/epcunms/getParamJson',


  requestCommon: '/lte/ems/subscriber/epcunms/requestCommon',
  delPdnProfile: '/lte/ems/subscriber/epcunms/requestCommon',
  qryPdnProfile: '/lte/ems/subscriber/epcunms/requestCommon',
  delProfile: '/lte/ems/subscriber/epcunms/requestCommon',
  qryProfile: '/lte/ems/subscriber/epcunms/requestCommon',
  delLteUser: '/lte/ems/subscriber/epcunms/requestCommon',
  qryLteUser: '/lte/ems/subscriber/epcunms/requestCommon',
  delRangeUser: '/lte/ems/subscriber/epcunms/requestCommon',
  qryProfileByID: '/lte/ems/subscriber/epcunms/requestCommon',

  udmJsonReq: '/lte/ems/subscriber/epcunms/getGParamJson',
  qryDnnProfile: '/lte/ems/subscriber/epcunms/requestCommonD',
  delCommonD: '/lte/ems/subscriber/epcunms/requestCommonD',
  snssaiJson: '/lte/ems/subscriber/epcunms/getGParamJson',
  qrySnssaiProfile: '/lte/ems/subscriber/epcunms/requestCommonD',
  amdataJson: '/lte/ems/subscriber/epcunms/getGParamJson',
  qryAmDataProfile: '/lte/ems/subscriber/epcunms/requestCommonD',
  plmnJson: '/lte/ems/subscriber/epcunms/getGParamJson',
  qryPlmnProfile: '/lte/ems/subscriber/epcunms/requestCommonD',
  usersubJson: '/lte/ems/subscriber/epcunms/getGParamJson',
  qryUsersubProfile: '/lte/ems/subscriber/epcunms/requestCommonD',
  qryAmDataProfileByPlmn: '/lte/ems/subscriber/epcunms/requestCommonD',
  qrySnssaiProfileByPlmn: '/lte/ems/subscriber/epcunms/requestCommonD',
  qryDnnProfileBySnssai: '/lte/ems/subscriber/epcunms/requestCommonD',
  requestCommonD: '/lte/ems/subscriber/epcunms/requestCommonD',

};

const ajaxUrlMock = {
  addPdnProfileJson: '/lte/hss/addPDNProfile.json',
  modPdnProfileJson: '/lte/hss/modPDNProfile.json',
  addProfileJson: '/lte/hss/addProfile.json',
  modProfileJson: '/lte/hss/modProfile.json',
  addLteUserJson: '/lte/hss/addLTEUser.json',
  modLteUserJson: '/lte/hss/modLTEUser.json',
  addBatchUserJson: '/lte/hss/addBatchLTEUser.json',

  requestCommon: '/lte/ems/subscriber/epcunms/requestCommon',
  delPdnProfile: '/lte/hss/delPDNProfileReq',
  qryPdnProfile: '/lte/hss/qryPDNProfile',
  delProfile: '/lte/hss/delProfileReq',
  qryProfile: '/lte/hss/qryProfile',
  delLteUser: '/lte/hss/delLTEUser',
  qryLteUser: '/lte/hss/qryLTEUser',
  qryProfileByID: '/lte/hss/qryPDNProfile',

  udmJsonReq: '/lte/ems/udm/udmSubsciber.json',
  qryDnnProfile: '/lte/ems/udm/qryDnnProfile',
  delCommonD: '/lte/ems/subscriber/epcunms/requestCommonD',
  snssaiJson: '/lte/ems/udm/snssaiSubsciber.json',
  qrySnssaiProfile: '/lte/ems/udm/qrySnssaiProfile',
  amdataJson: '/lte/ems/udm/amdataSubsciber.json',
  qryAmDataProfile: '/lte/ems/udm/qryAmDataProfile',
  plmnJson: '/lte/ems/udm/plmnSubsciber.json',
  qryPlmnProfile: '/lte/ems/udm/qryPlmnProfile',
  usersubJson: '/lte/ems/udm/usersubSubsciber.json',
  qryUsersubProfile: '/lte/ems/udm/qryUsersubProfile',
  qryAmDataProfileByPlmn: '/lte/ems/udm/qryAmDataProfile',
  qrySnssaiProfileByPlmn: '/lte/ems/udm/qrySnssaiProfile',
  qryDnnProfileBySnssai: '/lte/ems/udm/qryDnnProfile',
  requestCommonD: '/lte/ems/subscriber/epcunms/requestCommonD',

};

export default ajaxUrl;
